export default __webpack_public_path__ + "static/media/espiritual3.ea690e45.jpg";